<label *ngIf="to.label">{{ to.label }}</label>
<section>
  <mat-checkbox *ngIf="to.options as options"
                [indeterminate]="someSelected"
                [checked]="allSelected"
                (change)="toggleSelectAll($event.checked)">
    {{ to.selectAllLabel || 'All' }}
  </mat-checkbox>
  <ul>
    <ng-container *ngFor="let option of to.options let i = index;">

      <li class="tw-pl-6">
        <mat-checkbox
          [id]="id + '_' + i"
          [formlyAttributes]="field"
          [tabIndex]="to.tabindex"
          [color]="to.color"
          [checked]="isChecked(option)"
          [labelPosition]="to.labelPosition"
          (change)="onChange(option.value, $event.checked)">
          {{option.label}}
        </mat-checkbox>
      </li>

    </ng-container>
  </ul>
</section>
